import * as React from 'react';
import * as _ from 'lodash';
import { styled } from '../../../../theme';

export type MFAProviderIconWidgetProps = {
  image: string | (() => JSX.Element);
};

namespace S {
  const ICON_SIZE = 70;

  export const IconContainer = styled.div`
    font-size: ${ICON_SIZE}px;
    color: white;
  `;

  export const Icon = styled.div<{ src: string }>`
    width: ${ICON_SIZE}px;
    height: ${ICON_SIZE}px;
    background-image: url('${(p) => p.src}');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
  `;
}

export const MFAProviderIconWidget: React.FC<MFAProviderIconWidgetProps> = (props) => {
  const { image } = props;
  return _.isString(image) ? <S.Icon src={image} /> : <S.IconContainer>{image()}</S.IconContainer>;
};
